<template>
  <div class="contact-page">
      <section class="page-header">
        <h1>Contact Us</h1>
      </section>
      <div class="top-image">
      </div>


    <div class="content" @click="dropDownOpen = false">
      <div class="contact-inner">
         <div class="contactinfo">
           <img src="../assets/icon.svg">
           <p>
             <strong>Corporate Mailing Address</strong><br>
              Production Locations, Inc<br>
              9663 Santa Monica Blvd. #490<br>
              Beverly Hills, CA 90210
           </p>
           <p>
              <strong>Downtown Office</strong><br>
              756 S Broadway #1110<br>
              Los Angeles, CA 90014
           </p>
           <p>
             <strong>Call Us</strong><br>
              323.874.0404
           </p>
           <p>
             <strong>Email</strong><br>
              <A href="mailto:office@productionlocations.com">office@productionlocations.com</A>
           </p>
         </div><!-- /.contactinfo -->

         <div class="contactform">
           <template v-if="!formSubmitted">
              <p style="margin-bottom: 0;">I'd like to&hellip;</p>

              <div class="dropdown">
                <div class="selected" v-bind:class="{greyed: dropDownOpen}" v-on:click.stop="dropDownOpen = !dropDownOpen">{{selectedForm}} <i class="material-icons">expand_more</i></div>
                <ul class="menu" v-if='dropDownOpen'>
                  <li @click="selectedForm='Book a Property', dropDownOpen = false">Book a Property</li>
                  <li @click="selectedForm='Ask a General Question', dropDownOpen = false">Ask a General Question</li>
                  <li @click="selectedForm='List My Property for Filming', dropDownOpen = false">List My Property for Filming</li>
                </ul>
              </div>

              <div class="scout-form" v-if="selectedForm == 'Book a Property'">
                <p>Contact one of our scouts to book a location or get help with your search.</p>
                <form ref="scoutform" @submit.prevent="formSubmit('scoutform')">
                  <div class="form-left">
                    <label for="firstname">First Name</label>
                    <input type="text" name="firstname" placeholder="First Name" required>
                    <label for="lastname">Last Name</label>
                    <input type="text" name="lastname" placeholder="Last Name" required>
                    <label for="email">Email Address</label>
                    <input type="email" name="email" placeholder="Email" required>
                    <label for="phone">Phone Number</label>
                    <input type="text" name="phone" placeholder="Phone" required>
                    <label for="mobile">Mobile Number</label>
                    <input type="text" name="mobile" placeholder="Mobile">
                    <label for="address">Address</label>
                    <input type="text" name="address" placeholder="Address">
                    <label for="city">City</label>
                    <input type="text" name="city" placeholder="City">
                    <label for="state">State</label>
                    <select name="state" required>
                    	<option value="" disabled selected hidden>Select a State</option>
                    	<option value="AL">Alabama</option>
                    	<option value="AK">Alaska</option>
                    	<option value="AZ">Arizona</option>
                    	<option value="AR">Arkansas</option>
                    	<option value="CA">California</option>
                    	<option value="CO">Colorado</option>
                    	<option value="CT">Connecticut</option>
                    	<option value="DE">Delaware</option>
                    	<option value="DC">District Of Columbia</option>
                    	<option value="FL">Florida</option>
                    	<option value="GA">Georgia</option>
                    	<option value="HI">Hawaii</option>
                    	<option value="ID">Idaho</option>
                    	<option value="IL">Illinois</option>
                    	<option value="IN">Indiana</option>
                    	<option value="IA">Iowa</option>
                    	<option value="KS">Kansas</option>
                    	<option value="KY">Kentucky</option>
                    	<option value="LA">Louisiana</option>
                    	<option value="ME">Maine</option>
                    	<option value="MD">Maryland</option>
                    	<option value="MA">Massachusetts</option>
                    	<option value="MI">Michigan</option>
                    	<option value="MN">Minnesota</option>
                    	<option value="MS">Mississippi</option>
                    	<option value="MO">Missouri</option>
                    	<option value="MT">Montana</option>
                    	<option value="NE">Nebraska</option>
                    	<option value="NV">Nevada</option>
                    	<option value="NH">New Hampshire</option>
                    	<option value="NJ">New Jersey</option>
                    	<option value="NM">New Mexico</option>
                    	<option value="NY">New York</option>
                    	<option value="NC">North Carolina</option>
                    	<option value="ND">North Dakota</option>
                    	<option value="OH">Ohio</option>
                    	<option value="OK">Oklahoma</option>
                    	<option value="OR">Oregon</option>
                    	<option value="PA">Pennsylvania</option>
                    	<option value="RI">Rhode Island</option>
                    	<option value="SC">South Carolina</option>
                    	<option value="SD">South Dakota</option>
                    	<option value="TN">Tennessee</option>
                    	<option value="TX">Texas</option>
                    	<option value="UT">Utah</option>
                    	<option value="VT">Vermont</option>
                    	<option value="VA">Virginia</option>
                    	<option value="WA">Washington</option>
                    	<option value="WV">West Virginia</option>
                    	<option value="WI">Wisconsin</option>
                    	<option value="WY">Wyoming</option>
                    </select>
                    <label for="zip">Zip</label>
                    <input type="text" name="zip" placeholder="Zip">

                  </div>
                  <div class="form-right">
                    <label for="workingtitle">Working Title</label>
                    <input type="text" name="workingtitle" placeholder="Working Title">

                    <label for="company">Company</label>
                    <input type="text" name="company" placeholder="Company" required>

                    <div class="sidebyside">
                      <div>
                        <label for="datefrom">Start Date</label>
                        <input type="date" name="datefrom" placeholder="From">
                      </div>
                      <div>
                        <label for="dateto">End Date</label>
                        <input type="date" name="dateto" placeholder="To">
                      </div>
                    </div>

                    <div class="sidebyside">
                      <div>
                        <label for="daysshooting">Days Shooting</label>
                        <input type="number" name="daysshooting" placeholder="Days Shooting">
                      </div>
                      <div>
                        <label for="daysshooting">Days Prep</label>
                        <input type="number" name="daysprep" placeholder="Days Prep">
                      </div>
                    </div>
                    <div class="sidebyside">
                      <div>
                        <label for="daysshooting">Days Strike</label>
                        <input type="number" name="daysstrike" placeholder="Days Strike">
                      </div>
                      <div>
                      </div>
                    </div>

                    <label for="requestedlocation">Requested Location</label>
                    <textarea name="requestedlocation" placeholder="Specify location number or describe what you’re looking for"></textarea>

                    <label>Do you have insurance?</label>
                  <div class="radios"><input type="radio" name="insurance" value="Yes" id="insuranceyes"> <label for="insuranceyes">Yes</label> <input type="radio" name="insurance" value="No" id="insuranceno"> <label for="insuranceno">No</label></div>

                    <label>Have you worked with us before?</label>
                  <div class="radios"><input type="radio" name="workedbefore" value="Yes" id="workedbefore"> <label for="workedbefor">Yes</label> <input type="radio" name="workedbefore" value="No" id="workedbeforeno"> <label for="workedbeforeno">No</label></div>


                  </div>

                  <div ref="recaptcha" class="recaptcha"></div>

                  <button type="submit" v-if="!formLoading">Submit</button>
                  <button type="submit" v-else disabled="disabled">Sending..</button>
                </form>
              </div><!-- /scout-form -->

              <div class="general-form" v-if="selectedForm == 'Ask a General Question'">
                <p>Fill out the form below and someone from our office will get back to you.</p>
                <form ref="generalform" @submit.prevent="formSubmit('generalform')">
                  <div class="form-left">
                    <label for="firstname">First Name</label>
                    <input type="text" name="firstname" placeholder="First Name" required>
                    <label for="lastname">Last Name</label>
                    <input type="text" name="lastname" placeholder="Last Name" required>
                  </div>
                  <div class="form-right">
                    <label for="email">Email Address</label>
                    <input type="email" name="email" placeholder="Email" required>
                    <label for="phone">Phone Number</label>
                    <input type="text" name="phone" placeholder="Phone">
                  </div>
                  <label for="message">
                  Message
                  </label>
                  <textarea name="message" placeholder="Enter your message here" required></textarea>

                  <div ref="recaptcha" class="recaptcha"></div>

                  <button type="submit" v-if="!formLoading">Submit</button>
                  <button type="submit" v-else disabled="disabled">Sending..</button>
                </form>
              </div><!-- /general-form -->

              <div class="list-form" v-if="selectedForm == 'List My Property for Filming'">
                <p>To list your property fill out our <router-link :to="'/submitproperty'">property submission form</router-link>.</p>
                <p>If you have a question about your submission or any other questions please use our <a @click="selectedForm='Ask a General Question'">contact form</a>.</p>
              </div><!-- /list-form -->
           </template>
           <template v-else>
              <h1 class="received">Submission Received</h1>
              <p>Thank you! We'll get back to you as soon as possible.</p>
           </template>
         </div><!-- /.contactform -->
      </div>

      <div class="bottom-section">
      </div>


    </div><!-- /.content -->

  </div><!-- /.contact-page -->
</template>

<script>
export default {
  name: 'ContactPage',
  data () {
    return {
      selectedForm: 'Book a Property',
      dropDownOpen: false,
      formSubmitted: false,
      formLoading: false,
      sitekey: '6Lfr0owsAAAAABp_7N0xVdXR4A-L2wHs5lXZKyzk',
      recaptchaToken: null,
      widgetId: null
    }
  },
  mounted () {
    const checkGrecaptcha = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.render) {
        clearInterval(checkGrecaptcha)
        console.log('captcha loaded')
        this.$nextTick(() => {
          try {
            console.log(this.$refs.recaptcha)
            this.renderCaptcha()
          } catch (e) {
            console.error('Render failed:', e)
          }
        })
      }
    }, 100)
  },
  created () {
    document.title = 'Contact Us - Production Locations'
    document.head.querySelector('meta[name=description]').content = 'Contact our experienced scouting team to help find and book the perfect location for your production'
  },
  watch: {
    selectedForm (value) {
      this.$nextTick(() => {
        this.renderCaptcha()
      })
    }
  },
  methods: {
    renderCaptcha () {
      if (window.grecaptcha && this.$refs.recaptcha) {
        this.widgetId = window.grecaptcha.render(this.$refs.recaptcha, {
          'sitekey': '6Lfr0owsAAAAABp_7N0xVdXR4A-L2wHs5lXZKyzk',
          'callback': (token) => {
            this.recaptchaToken = token
          }
        })
      }
    },
    formSubmit (formName) {
      if (!this.recaptchaToken) {
        alert('Please complete the reCAPTCHA')
        return
      }
      this.formLoading = true
      var formData = new FormData(this.$refs[formName])
      var fields = {}
      formData.forEach(function (value, key) { fields[key] = value })
      fields.formname = formName
      this.$http.post(this.$root.apiurl + 'contact', fields).then(response => {
        this.formSubmitted = true
      }, response => {
        console.log(response.statusText)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";

.content {
  background: #F3F3F3;
  .contact-inner {
    max-width: 1120px;
    margin: 0px auto;
    padding: 1em 1em;
    min-height: 50vh;
    @include bp(most) {
      padding: 4em 1em;
    }
  }
}
  .contactinfo {
    vertical-align: top;
    @include bp(most) {
      display: inline-block;
      width: 25%;
      border-right: 2px solid #CBCBCB;
      padding: 2em 0;
      margin-top: 4em;
    }
    img {
      width: 32px;
      height: 32px;
      display: block;
      @include bp(most) {
        display: block;
        width: 68px;
        height: 68px;
      }
    }
    p {
      font-family: $noto;
      color: $notblack;
      display: inline-block;
      vertical-align: top;
      width: 47%;
      font-size: .75em;
      margin-bottom: .5em;
      @include bp(most) {
        display: block;
        width: 100%;
        margin-bottom: .75em;
        font-size: 1em;
      }
    }
    a {
      color: $notblack;
      text-decoration: none;
    }
  }
  .contactform {
    @include bp(most) {
      display: inline-block;
      vertical-align: top;
      width: 74%;
      padding-left: 6.5%;
      box-sizing: border-box;
    }
  }

.bottom-section {
  background: $yellow;
  height: 8em;
  text-align: center;
  display: none;
  @include bp(most) {
    display: block;
  }
}

.dropdown {
  font-size: 1.5em;
  font-weight: 300;
  cursor: pointer;
  margin-bottom: 1em;
  position: relative;
  @include noselect();
  @include bp(most) {
    font-size: 2.5em;
  }
  .selected {
    position: relative;
    border-bottom: 2px solid #979797;
    padding: .5em 0;
    @include bp(most) {
      width: 14.5em;
      padding: .25em 0;
    }
    i {
      position: absolute;
      right: 4px;
      top: 16px;
      @include bp(most) {
        top: 22px;
      }
    }
    &:hover {
      i {

      }
      border-bottom: 2px solid $notblack;
    }
    &.greyed {
      color: #979797;
    }
  }
  ul {
    margin: 0px;
    padding: 0px;
    list-style-type: none;
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    @include bp(most) {
      width: 14.5em;
    }
    li {
      padding: .5em .25em;
      background: #f3f3f3;
      border-bottom: 2px solid #979797;
      @include bp(most) {
        padding: .25em;
      }
      &:hover {
        background: $yellow;
      }
    }
  }
}

.list-form {
  padding-bottom: 25em;
}

p {
  font-family: $noto;
  line-height: 1.5;
}

.form-left {
  @include bp(most) {
    display: inline-block;
    vertical-align: top;
    width: 45%;
    margin-right: 9%;
  }
}
.form-right {
  @include bp(most) {
    display: inline-block;
    vertical-align: top;
    width: 45%;
  }
}

form {
  padding-top: 1em;
}

.sidebyside {
  height: 5.125em;
  clear: both;
  & > div {
    width: 49%;
    display: inline-block;
    &:last-child {
      margin-left: .5%;
    }
  }
}

  label {
    display: block;
    font-family: $noto;
    color: #8A8A8A;
    margin: .25em 0;
  }
  input[type=text], input[type=email], input[type=date], input[type=number] {
    font-family: $noto;
    display: block;
    text-align: left;
    width: 100%;
    outline: none;
    padding: .75em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 1px solid #7D7D7D;
    border-radius: 3px;
    color: $notblack;
    background: #FBFBFB;
    &::-webkit-datetime-edit-year-field:not([aria-valuenow]),
    &::-webkit-datetime-edit-month-field:not([aria-valuenow]),
    &::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
        color: transparent;
    }
    &::placeholder {
      color: #CFCFCF;
    }
    &:focus {
      background: #FFF;
    }
  }

  select {
    font-family: $noto;
    display: block;
    text-align: left;
    width: 100%;
    outline: none;
    height: 3em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 1px solid #7D7D7D;
    border-radius: 3px;
    color: $notblack;
    background: #FBFBFB;
    padding-left: .75em;
    -webkit-appearance: textfield;
    &:required:invalid {
      color: #CFCFCF;
    }
  }
  .radios {
    padding: .75em 0;
    input {
      display: inline-block;
    }
    label {
      display: inline-block;
      color: $notblack;
      margin-right: 1em;
    }
  }
  textarea {
    font-family: $noto;
    display: block;
    text-align: left;
    width: 100%;
    outline: none;
    padding: .75em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 1px solid #7D7D7D;
    border-radius: 3px;
    color: $notblack;
    background-color: #FBFBFB;
    height: 10em;
    &:focus {
      background-color: #FFF;
    }
    &::placeholder {
      color: #CFCFCF;
    }
  }
  .scout-form textarea {
    height: 8.825em;
  }
  button {
    background: $blue;
    outline: none;
    border: 0px none;
    border-radius: 3px;
    font-family: $montserrat;
    color: #FFF;
    font-weight: 300;
    font-size: 1.25em;
    padding: .5em 1.5em;
    line-height: 1.4;
    &:disabled {
      background: #7d7d7d;
    }
  }

  h1.received {
    font-weight: 300;
    @include bp(most) {
      font-size: 36px;
    }
  }

  div.recaptcha {
    padding-bottom: 1em;
  }
</style>



// WEBPACK FOOTER //
// ContactPage.vue?37c40bb3